import { Component, OnInit } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Website} from '../../../models/website.model';
import {DialogNewSiteComponent} from './dialogs/dialog-new-site/dialog-new-site.component';
import {MatDialog} from '@angular/material/dialog';
import {WccService} from '../../../services/wcc-service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DialogConfirmationComponent} from '../../../dialogs/dialog-confirmation/dialog-confirmation.component';

@Component({
  selector: 'app-streamup-my-sites',
  templateUrl: './my-sites.component.html',
  styleUrls: ['./my-sites.component.scss']
})
export class MySitesComponent implements OnInit {

    loadingWebsites$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    hasWebsites$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    websites$: BehaviorSubject<Website[]> = new BehaviorSubject<Website[]>([]);

  constructor(
      private dialog: MatDialog,
      private wccService: WccService,
      public snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.getWebsites();
  }

    getWebsites(){
        this.loadingWebsites$.next(true);
        this.wccService.getWebsites()
            .subscribe((websites: Website[]) => {
                this.websites$.next(websites);
                this.hasWebsites$.next(websites.length > 0);
                this.loadingWebsites$.next(false);
            });
    }

  removeWebsite(website: Website){
      return this.dialog
          .open(DialogConfirmationComponent, {
              data: {
                  message: 'Deleting this website will also permanently remove all records related to it. This action cannot be undone! Are you sure you want to delete website "' + website.name + '"?',
              },
              width: '600px',
              role: 'dialog'
          })
          .afterClosed()
          .subscribe(respCode => {
              switch (respCode) {
                  case -1: // Return button
                      break;
                  case 0: // Complete
                      break;
                  case 1: // Complete
                      this.wccService.removeWebsite(website.id)
                          .subscribe((response: any) => {
                              if (!response.error){
                                  this.snackBar.open('Operation successfully completed!', null, {duration: 1000});
                                  this.getWebsites();
                              }else{
                                  this.snackBar.open('An error occurred!', null, {duration: 1000});
                              }
                          });
                      break;
              }
          });
  }

  editSite(website: Website) {
    if (website === null) {
          website = new Website(-1, '', '', false, null, null);
      }
    return this.dialog
        .open(DialogNewSiteComponent, {
          data: {
            site: website,
          },
          width: '600px',
          role: 'dialog'
        })
        .afterClosed()
        .subscribe(respCode => {
            switch (respCode) {
              case -1: // Return button
                break;
              case 0: // Complete
                  this.snackBar.open('An error occurred!', null, {duration: 1000});
                  break;
              case 1: // Complete
                  this.snackBar.open('Operation successfully completed!', null, {duration: 1000});
                  this.getWebsites();
                  break;
            }
        });
  }
}
